/* jshint esversion: 6, -W097 */
/* globals module */
"use strict";

FlatPageService.$inject = [
    '$q',
    '$http',
    'ProductApiConsumerService',
    'UtilService',
];
function FlatPageService(
    $q,
    $http,
    ProductApiConsumerService,
    UtilService
) {
    let _htmlContent = null,
        _wagtailContent = null,
        _wagtailSettings = null;

    return {
        fetchFlatPageContent: fetchFlatPageContent,
        getFlatPageContent: getFlatPageContent,
        fetchWagtailSettings: fetchWagtailSettings,
        getWagtailSettings: getWagtailSettings,
        getKnownFlatPages: getKnownFlatPages,
        getFlatPageSlugs: getFlatPageSlugs,
        fetchWagtailContent: fetchWagtailContent,
        getWagtailContent: getWagtailContent
    };


    /**
     * Retrieves flat page contents from backend based on the given type and parameters
     *
     */
    function fetchFlatPageContent(type, params) {
        return ProductApiConsumerService.get(
            '/api/1.0/flatbox/' + type + '/',
            {
                params: params
            }
        ).then(function(response){
            _htmlContent = response.data.content;
        }, function(){
            _htmlContent = false;
        }).catch(function() {
            _htmlContent = false;
        });
    }


    /**
     * Gets the retrieved html content
     * @returns {*}
     */
    function getFlatPageContent() {
        return _htmlContent;
    }

    /**
     * Fetches a settings object from the given Wagtail instance.
     * @returns {*}
     */
    function fetchWagtailSettings() {
        return $http.get(
            UtilService.getSiteSetting('cms_base_url') + 'marketplace-settings/'
        ).then(function(response){
            _wagtailSettings = response.data;
        }, function() {
            _wagtailSettings = null;
        });
    }

    /**
     * Returns the settings object from Wagtail.
     * @returns {*}
     */
    function getWagtailSettings() {
        return _wagtailSettings;
    }

    /**
     * Gets a map of available flat pages
     * @returns {*}
     */
    function getKnownFlatPages() {
        let flatPages = [];
        const defer = $q.defer();
        if (getWagtailSettings() === null) {
            fetchWagtailSettings().then(() => {
                flatPages = getWagtailSettings().available_pages || {};
                defer.resolve(flatPages);
            });
        } else {
            flatPages = getWagtailSettings().available_pages || {};
            defer.resolve(flatPages);
        }
        return defer.promise;
    }

    /**
     * Splices the leading slash in the flat page endpoints to check codes against
     * @returns {Array}
     */
    function getFlatPageSlugs() {
        return getKnownFlatPages().then( (flatPages) => {
            const endpoints = Object.keys(flatPages);
            const slugs = [];
            endpoints.forEach((endpoint) => {
                slugs.push(endpoint.substr(1));
            });
            return slugs;
        });
    }

    /**
     * Fetches flat page content from Wagtail based on a page id.
     * @param id
     * @returns {*}
     */
    function fetchWagtailContent(id) {
        return $http.get(
            UtilService.getSiteSetting('cms_base_url') + 'pages/' + id + '/'
        ).then(function(response){
            if (response.data.length === 0){
                _wagtailContent = false;
            } else {
                _wagtailContent = response.data;
            }
        }, function(){
            _wagtailContent = false;
        });
    }

    /**
     * Returns the fetched Wagtail page content.
     * @returns {*}
     */
    function getWagtailContent() {
        return _wagtailContent;
    }
}

module.exports = FlatPageService;